{
  "close": "Zatvoriť",
  "notifications": "{count, plural, one {# oznámenie} few {# oznámenia} other {# oznámení}}."
}
